export default __webpack_public_path__ + "static/media/insta-4-comp.8d30bd35.jpg";